<div
  class="custom-select-container"
  [class.disabled]="disabled()"
  role="combobox"
  aria-haspopup="listbox"
  [attr.aria-expanded]="isOpen()"
  tabindex="0"
  (click)="toggleDropdown()"
  (keydown)="(null)"
>
  <div class="custom-select-selected small" [class.open]="isOpen()">
    @if (!value().length) {
      <span class="placeholder">{{ placeholder() }}</span>
    } @else if (multiple()) {
      @for (selected of value(); track $index) {
        <div class="chip">
          <div class="chip-text">
            @if (optionTemplate()) {
              <ng-container *ngTemplateOutlet="optionTemplate(); context: { $implicit: selected }"></ng-container>
            } @else {
              {{ selected.title }}
            }
          </div>
        </div>
      }
    } @else {
      @if (optionTemplate()) {
        <ng-container *ngTemplateOutlet="optionTemplate(); context: { $implicit: value()[0] }"></ng-container>
      } @else {
        {{ value()[0].title }}
      }
    }
    <span class="arrow"></span>
  </div>
  @if (isOpen()) {
    @let hasSearch = this.options().length > 5;
    <ul
      #dropdownList
      class="custom-select-options"
      [class.has-search]="hasSearch"
      @dropdown
      role="listbox"
      tabindex="-1"
      [attr.aria-activedescendant]="availableOptionIndices().has(this.highlightedIndex()) ? 'option-' + this.highlightedIndex() : null"
    >
      @if (hasSearch) {
        <input
          #searchInput
          [(ngModel)]="searchQuery"
          (click)="$event.stopPropagation()"
          class="search-query"
          [placeholder]="'translations.global.label.search' | transloco"
          [class.has-error]="this.availableOptionIndices().size === 0"
        />
      }

      @for (option of options(); track $index) {
        @if (availableOptionIndices().has($index)) {
          <li
            role="option"
            class="medium"
            [id]="'option-' + $index"
            [attr.aria-selected]="isSelected(option)"
            [class.selected]="isSelected(option)"
            [class.disabled]="multiple() && maxSelection() && !isSelected(option) && value().length >= maxSelection()"
            [class.highlighted]="$index === highlightedIndex()"
            (click)="selectOption($event, option)"
            (keydown)="(null)"
            (mouseenter)="highlightedIndex.set($index); highlightedByMouse.set(true)"
          >
            @if (multiple()) {
              <input
                type="checkbox"
                tabindex="-1"
                [checked]="isSelected(option)"
                (click)="$event.stopPropagation()"
                [disabled]="maxSelection() && !isSelected(option) && value().length >= maxSelection()"
              />
            }
            @if (optionTemplate()) {
              <ng-container *ngTemplateOutlet="optionTemplate(); context: { $implicit: option }"></ng-container>
            } @else {
              {{ option.title }}
            }
          </li>
        }
      }
    </ul>
  }
</div>
